import { useLeafletContext } from "@react-leaflet/core";
import { useEffect, useState } from "react";
import { ButtonGroup, ToggleButton } from "react-bootstrap";
import { ResizeAwareDiv } from "../common/components/ResizeablePanel";
import { useSubscribe } from "../common/hooks/broadcastHook";
import { useMapView } from "../reducers/mapViewSlice";
import { LeafletLayersControl } from "./leaflet/LeafletLayersControls";
import { WindyContainer } from "./leaflet/WindyContainer";
// import { ActiveJobLayer, CrewLayer, LocationLayer } from "./map/Maker";
import { PathLayers } from "./map/Path";
import { Overlays } from "./map/TileLayer";
import { ZoneLayers } from "./map/Zone";
import { GuideButton } from "../common/components/GuideButton";

const ViewManager = () => {
  const { map } = useLeafletContext();
  const view = useMapView();

  useSubscribe('locate', obj => map.setView([obj.latitude, obj.longitude]), [map]);

  useEffect(() => {
    if (map) {
      map.setView([view.latitude, view.longitude])
      map.setZoom();
    }
  }, [map, view])
}

const ForecastMap = () => {
  return <ResizeAwareDiv><WindyContainer center={[51.505, -0.09]} zoom={13} scrollWheelZoom={true} style={{ height: '100%' }} apiKey="lWHThrByqWHjilNcFfp1ufNznQwsr20w">
    <ViewManager></ViewManager>
    <LeafletLayersControl position="topleft" autoZIndex={false}>
      {/* <ActiveJobLayer mode='leaflet' showLabel={false}></ActiveJobLayer>
        <CrewLayer mode='leaflet' showLabel={false}></CrewLayer>
        <LocationLayer mode='leaflet' showLabel={true}></LocationLayer>*/}
      <ZoneLayers mode='leaflet' zIndex={50}></ZoneLayers>
      <PathLayers mode='leaflet' zIndex={60}></PathLayers>
      <Overlays mode='leaflet' zIndex={40}></Overlays>
    </LeafletLayersControl>
  </WindyContainer></ResizeAwareDiv>
}

const LiveWeatherMap = () => {
  const [center, setCenter] = useState({ latitude: 51.505, longitude: -0.09 });
  const [zoom, setZoom] = useState(13);
  const view = useMapView();
  const [isDragging, setIsDragging] = useState(false);

  useEffect(() => {
    const enableOverlay = (event) => setIsDragging(true);
    const disableOverlay = (event) => setIsDragging(false);

    document.addEventListener('dragstart', enableOverlay);
    document.addEventListener('dragend', disableOverlay);

    return () => {
      // Clean up event listeners on component unmount
      document.removeEventListener('dragstart', enableOverlay);
      document.removeEventListener('dragend', disableOverlay);
    };
  }, []);

  useSubscribe('locate', obj => setCenter({ latitude: obj.latitude, longitude: obj.longitude }), []);

  useEffect(() => {
    setCenter({ latitude: view.latitude, longitude: view.longitude });
    setZoom(view.zoom);
  }, [view])

  return <div style={{ position: 'relative', width: '100%', height: 'calc(100% - 10px)' }}>
    <iframe style={{ width: '100%', height: '100%', pointerEvents: isDragging ? 'none' : 'auto' }} title="Windy Weather Map" src={`https://embed.windy.com/embed.html?type=map&location=coordinates&metricRain=default&metricTemp=default&metricWind=default&zoom=${Math.min(7, zoom ?? 7)}&overlay=radar&product=radar&level=surface&lat=${center.latitude}&lon=${center.longitude}`} frameBorder="0"></iframe>
    {isDragging ? <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(255,255,255,0)', zIndex: 999 }}></div> : null}
  </div>
}

const WeatherMap = () => {
  const [radar, setRadar] = useState(true);
  return <div id="weatherMap" className="w-100 h-100" style={{ position: 'relative' }}>
    {radar ? <LiveWeatherMap></LiveWeatherMap> : <ForecastMap></ForecastMap>}
    <ButtonGroup style={{ position: 'absolute', bottom: '90px', left: '16px', zIndex: 5 }} toggle={true}>
      <ToggleButton variant="secondary" type="radio" checked={radar} value={true} onChange={v => setRadar(true)}>Radar</ToggleButton>
      <ToggleButton variant="secondary" type="radio" checked={!radar} value={false} onChange={v => setRadar(false)}>Forecast</ToggleButton>
      <GuideButton variant="secondary" guide={79040}></GuideButton>
    </ButtonGroup>
  </div>
}

export default WeatherMap;